import ExampleComponent from './ExampleComponent';

export default [
  {
    path: '/example',
    component: ExampleComponent
  }
];



// WEBPACK FOOTER //
// ./src/ExampleComponent/routes.js